import { FutureResponseModel } from 'models';
import React, { Fragment, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import FutureOddButton from './FutureOddButton';
import Typo from 'consts/typography';
import { useAppSelector, useAppTranslation } from 'app/hooks';
import { platformStates } from 'redux/platformSlice';

interface FutureOddsProps {
  future: FutureResponseModel;
}

const FutureOdds: React.FunctionComponent<FutureOddsProps> = ({ future }) => {
  const [isExpand, setIsExpand] = useState<boolean>(false);
  const { isPhone } = useAppSelector(platformStates);
  const t = useAppTranslation();
  return (
    <div className="future-odds">
      <div className="future-odds__header">
        <p className="name-prize">
          {future.league} - {future.name}
        </p>
        {/* {future.amountUserBetFuture !== 0 && (
          <div className="amount-user-placed">
            <span className={` ${isPhone ? Typo.p9 : Typo.p5}`}>
              {future.amountUserBetFuture} {t('game.placed-bet')}
            </span>
          </div>
        )} */}
      </div>
      <div className={`future-odds__content  `}>
        {future.futureOdds
          .slice()
          .sort((a, b) => a.decimalPrice - b.decimalPrice)
          .map((row, index) =>
            !isExpand && index >= 6 ? null : (
              <div key={row.id} className="column-odd">
                <div className="flex-row items-center gap-1">
                  <img
                    className="column-odd__logo"
                    src={row.teamLogo}
                    alt="default logo"
                    onError={(e) => {
                      e.currentTarget.src = '/defaultImage.png';
                    }}
                  />
                  <span className="column-odd__name primary-text-color">{row.name}</span>
                </div>
                <div className="column-odd__button primary-text-color">
                  <FutureOddButton
                    odd={row}
                    index={index}
                    futureId={future.id}
                    team={row.name}
                    category={future.sport}
                    league={future.name}
                  />
                </div>
              </div>
            ),
          )}
      </div>
      {future.futureOdds.length > 6 && (
        <div className="future-odds__footer">
          <button
            className="footer-control-button primary-text-color"
            onClick={() => setIsExpand((prev) => !prev)}
          >
            {isExpand ? (
              <Fragment>
                Show less
                <FaChevronUp className="footer-control-button__icon primary-text-color" />
              </Fragment>
            ) : (
              <Fragment>
                Show more
                <FaChevronDown className="footer-control-button__icon primary-text-color" />
              </Fragment>
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default FutureOdds;
